/* istanbul ignore file */

import { connect } from 'react-redux';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';
import type { Dispatch } from 'redux';

import { ListingsControlsDrawer } from 'src/components/organisms/ListingsControlsDrawer/ListingsControlsDrawer';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectActiveNonTaxonomyFacets } from 'src/redux/productsQuery/selectors/selectors';
import { actions } from 'src/redux/productsQuery/slice';
import { getViewResultsButtonText } from './getViewResultsButtonText';
import type {
  ListingsControlsDispatchProps,
  ListingsControlsDrawerStateProps,
} from './ListingsControlsDrawer';

const mapStateToProps = (state: ReduxApplicationState): ListingsControlsDrawerStateProps => {
  const { products, productsQuery } = state;

  return {
    drawerCTAButtonText: getViewResultsButtonText(products),
    drawerOpen: productsQuery.isModalOpen,
    loading: products.pageLoading !== null,
    totalActiveFacets: selectActiveNonTaxonomyFacets(state).length,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): ListingsControlsDispatchProps => {
  return {
    closeDrawer: () => dispatch(actions.closeModal()),
    onDrawerCTAButtonClick: () => {
      // Defer off the interaction's critical path: fire-and-forget, does not gate the drawer closing.
      deferTracking(() =>
        sendGAEvent({
          event: 'custom_event_v2',
          event_name: 'filter_interaction',
          event_details: 'view results',
          content_type: 'filters',
          modal_details: {
            name: 'plp_filter_facet',
            type: 'mobile_drawer',
            action: 'view results',
            page_type: 'plp',
          },
        }),
      );
      dispatch(actions.closeModal());
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const ListingsControlsDrawerContainer = connector(ListingsControlsDrawer);
